import React, { useState, useRef } from 'react';
import PoweredLabel from '@gumtree/ui-library/src/powered-label';
import RatingStars from '@gumtree/ui-library/src/rating-stars/rating-stars';
import { AdReview } from '../../../types/ad-reviews';
import {
    ReviewItemWrapper,
    ReviewerName,
    RatingRow,
    StarsContainer,
    ReviewDate,
    ReviewText,
    ShowMoreButton
} from './index.style';
import { starsContainerCss } from '../ad-reviews-score/index.style';

const formatDate = (timestamp: string): string => {
    const date = new Date(parseInt(timestamp));
    return date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
};

export interface AdReviewItemProps extends AdReview {}

const AdReviewItem: React.FC<AdReviewItemProps> = ({ 
    reviewerName, 
    date, 
    rating, 
    type, 
    text 
}) => {
    const [showFullText, setShowFullText] = useState(false);
    const textRef = useRef<HTMLParagraphElement>(null);

    const shouldShowMoreButton = () => {
        return text && text.length > 200;
    };

    const getDisplayText = (): string => {
        if (!text || showFullText) return text;
        
        return text;
    };

    const toggleShowMore = () => {
        setShowFullText(!showFullText);
    };

    return (
        <ReviewItemWrapper>
            <ReviewerName>{reviewerName}</ReviewerName>
            <RatingRow>
                <StarsContainer css={starsContainerCss}>
                    <RatingStars rating={Number(rating.toFixed(1))} />
                </StarsContainer>
                <ReviewDate>{formatDate(date)}</ReviewDate>
            </RatingRow>
            <PoweredLabel type={type} />
            <ReviewText ref={textRef} $showFullText={showFullText}>{getDisplayText()}</ReviewText>
            {shouldShowMoreButton() && (
                <ShowMoreButton onClick={toggleShowMore}>
                    {showFullText ? (
                        <>
                            Show less <span className="icon icon--chevron-up" aria-hidden="true" />
                        </>
                    ) : (
                        <>
                            Show more <span className="icon icon--chevron-down" aria-hidden="true" />
                        </>
                    )}
                </ShowMoreButton>
            )}
        </ReviewItemWrapper>
    );
};

export default AdReviewItem;
